export const getPort = (market) => {
  switch (market) {
    case "tadawul": return "https://tadawul-api.saudidune.com";
    case "nasdaq":  return "https://nasdaq-api.saudidune.com";
    case "psx":     return "https://psx-api.saudidune.com";
    case "nse":     return "https://nse-api.saudidune.com";
    case "egx":     return "https://egx-api.saudidune.com";
    case "qse":     return "https://qse-api.saudidune.com";
    case "dfm":     return "https://dfm-api.saudidune.com";
    case "dj":      return "https://dj-api.saudidune.com";
    case "us":      return "https://sp500-api.saudidune.com";
    case "crypto":  return "https://crypto-api.saudidune.com";
    case "amex":    return "https://usetf-api.saudidune.com";
    case "metals":  return "https://metals-api.saudidune.com";
    default:        return "https://tadawul-api.saudidune.com";
  }
};
